import qs from 'qs';
import httpCmsService from './httpCmsService';
import { DEFAULT_LOCALE } from '../i18n';

const toSearchParams = (query) =>
  new URLSearchParams(typeof query === 'string' ? query : qs.stringify(query));

const localizeContents = async (entries, locale, populateSource) => {
  if (locale === DEFAULT_LOCALE || !entries?.length) {
    return entries;
  }

  const params = new URLSearchParams({
    locale,
    'pagination[limit]': entries.length,
  });
  entries.forEach(({ documentId }, index) => {
    params.append(`filters[documentId][$in][${index}]`, documentId);
  });
  populateSource.forEach((value, key) => {
    if (key.startsWith('populate')) {
      params.append(key, value);
    }
  });

  const response = await httpCmsService.get(`/contents?${params}`);
  const translations = new Map(
    response.data.data.map((translation) => [
      translation.documentId,
      translation,
    ])
  );

  return entries.map((entry) => {
    const translation = translations.get(entry.documentId);
    return translation ? { ...translation, slug: entry.slug } : entry;
  });
};

const contentService = {
  getContents: async (query, locale = DEFAULT_LOCALE) => {
    const params = toSearchParams(query);
    params.set('locale', DEFAULT_LOCALE);

    const response = await httpCmsService.get(`/contents?${params}`);
    const entries = await localizeContents(response.data.data, locale, params);

    return { ...response.data, data: entries };
  },

  getContentBySlug: async (slug, locale = DEFAULT_LOCALE, populate = {}) => {
    const { data } = await contentService.getContents(
      { 'filters[slug][$eq]': slug, 'pagination[limit]': 1, ...populate },
      locale
    );
    return data?.[0] ?? null;
  },
};

export default contentService;
